import React from 'react';
import classNames from 'classnames';
import sharedButtonStyles from '../../button/Button.module.css';
import DebounceButton from '../../button/DebounceButton';
import styles from './KickInput.module.css';
import Tooltip from '../../tooltip/Tooltip';
import { TOOLTIP } from '../../../constants/strings';
import { KICK_TYPE } from '../../../constants/constants';

const generalIcon = require('../../../assets/icons/general.svg').default;
const flutterIcon = require('../../../assets/icons/flutter.svg').default;
const kickIcon = require('../../../assets/icons/kick.svg').default;
const swishIcon = require('../../../assets/icons/swish.svg').default;
const rollIcon = require('../../../assets/icons/roll.svg').default;
const infoIcon = require('../../../assets/icons/info_icon_turquoise.svg').default;

export default function KickInput({
  onPress, disabled,
}) {
  return (
    <div className={styles.gridContainer}>
      <DebounceButton
        disabled={disabled}
        className={classNames(styles.longItem, sharedButtonStyles.FCButtonEnabled)}
        onClick={() => onPress(KICK_TYPE.GENERAL)}
      >
        <img
          className={styles.icon}
          src={infoIcon}
          alt=""
          data-tip={TOOLTIP.KICK_GENERAL}
        />
        <img src={generalIcon} alt="" />
        &nbsp;&nbsp;
        {KICK_TYPE.GENERAL}
      </DebounceButton>
      <DebounceButton
        disabled={disabled}
        className={classNames(styles.shortItem, sharedButtonStyles.FCButtonEnabled)}
        onClick={() => onPress(KICK_TYPE.FLUTTER)}
      >
        <img
          className={styles.icon}
          src={infoIcon}
          alt=""
          data-tip={TOOLTIP.KCIK_FLUTTER}
        />
        <img src={flutterIcon} alt="" />
        &nbsp;&nbsp;
        {KICK_TYPE.FLUTTER}
      </DebounceButton>
      <DebounceButton
        disabled={disabled}
        className={classNames(styles.shortItem, sharedButtonStyles.FCButtonEnabled)}
        onClick={() => onPress(KICK_TYPE.KICK)}
      >
        <img
          className={styles.icon}
          src={infoIcon}
          alt=""
          data-tip={TOOLTIP.KICK_KICK}
        />
        <img src={kickIcon} alt="" />
        &nbsp;&nbsp;
        {KICK_TYPE.KICK}
      </DebounceButton>
      <DebounceButton
        disabled={disabled}
        className={classNames(styles.shortItem, sharedButtonStyles.FCButtonEnabled)}
        onClick={() => onPress(KICK_TYPE.SWISH)}
      >
        <img
          className={styles.icon}
          src={infoIcon}
          alt=""
          data-tip={TOOLTIP.KICK_SWISH}
        />
        <img src={swishIcon} alt="" />
        &nbsp;&nbsp;
        {KICK_TYPE.SWISH}
      </DebounceButton>
      <DebounceButton
        disabled={disabled}
        className={classNames(styles.shortItem, sharedButtonStyles.FCButtonEnabled)}
        onClick={() => onPress(KICK_TYPE.ROLL)}
      >
        <img
          className={styles.icon}
          src={infoIcon}
          alt=""
          data-tip={TOOLTIP.KICK_ROLL}
        />
        <img src={rollIcon} alt="" />
        &nbsp;&nbsp;
        {KICK_TYPE.ROLL}
      </DebounceButton>
      <Tooltip />
    </div>
  );
}
